var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-12 grey--text"},[_c('v-icon',{attrs:{"size":"56","color":"grey lighten-1"}},[_vm._v(_vm._s(_vm.icone))]),_c('p',{staticClass:"mt-3 mb-0"},[_vm._v(_vm._s(_vm.mensagem))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }